import React from 'react';
import { StyledCTA, StyledBannerCTA } from './styles';
import EnergiportalenLogo from '../../assets/images/energiportalen.png';
import useIsDesktop from '../../hooks/v2/useDesktop';
import matomo from '../../utils/matomo';

const EnergiportalenCallToAction = ({ className, smallVersion }) => {
  const isDesktop = useIsDesktop();

  const ctaClicked = () => {
    matomo.clickEvent({
      category: 'Boligmappa Energiportalen',
      action: 'Clicked Energiportalen Banner',
      name: 'Clicked Energiportalen Banner',
    });
  };

  if (smallVersion) {
    return (
      <StyledBannerCTA>
        <div className="banner_content">
          <img
            alt="Boligmappa+Logo"
            src={EnergiportalenLogo}
            className="boligmappa-plus-logo"
          />
          <p>Energisjekk din bolig nå!</p>
        </div>
        <a
          href="https://boligmappa.energiportalen.no/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={ctaClicked}
        >
          <button type="submit" className="banner_content_action">
            Lær mer
          </button>
        </a>
      </StyledBannerCTA>
    );
  }
  return (
    <StyledCTA className={className}>
      <div className="text_section">
        {isDesktop && (
          <div className="new_batch">
            <p className="new_text">Nyhet!</p>
          </div>
        )}
        <h2>
          {isDesktop
            ? 'Energisjekk din bolig nå!'
            : 'Energisjekk din bolig nå!'}
        </h2>
        <p>
          {isDesktop
            ? 'Vet du hvor mye energi du bruker til oppvarming, varmtvann og lys hjemme? Eller hvor mye du kan spare på strømregningen din ved å redusere energibruken i hjemmet ditt? På Energiportalen kan du sjekke selv!'
            : 'Vet du hvor mye energi du bruker til oppvarming, varmtvann og lys hjemme? På Energiportalen kan du sjekke selv!'}
        </p>
        <div className="button_section">
          <a
            href="https://boligmappa.energiportalen.no/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={ctaClicked}
          >
            <button type="submit" className="early_bird">
              {isDesktop ? 'Sjekk din bolig' : 'Les mer'}
            </button>
          </a>
        </div>
      </div>
      <div className="image_section">
        <img
          alt="Boligmappa+"
          src={EnergiportalenLogo}
          className="landscape-horizonal"
        />
      </div>
    </StyledCTA>
  );
};

export default EnergiportalenCallToAction;
